// assets
import { IconChartHistogram, IconTextWrapDisabled, IconUsers } from '@tabler/icons-react';

// type
import { store } from 'src/store';

// icons
const icons = {
  IconChartHistogram,
  IconUsers,
  IconTextWrapDisabled
};

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

let currentMenuItems: any = [];

// Define the pages and their structure
const pages = [
  {
    id: 'home',
    title: 'Home',
    type: 'collapse',
    icon: icons.IconTextWrapDisabled,
    children: [
      {
        id: 'home',
        title: 'Home',
        type: 'item',
        url: '/home',
        target: false
      }
    ]
  },
  {
    id: 'office',
    title: 'Office',
    type: 'collapse',
    icon: icons.IconTextWrapDisabled,
    children: [
      {
        id: 'office',
        title: 'Office List',
        type: 'item',
        url: '/office',
        target: false
      }
    ]
  },
  {
    id: 'employees',
    title: 'Employees',
    type: 'collapse',
    icon: icons.IconUsers,
    children: [
      {
        id: 'employees',
        title: 'Employees List',
        type: 'item',
        url: '/employees',
        target: false
      },
      {
        id: 'transfer-pool',
        title: 'Common Transfer Pool',
        type: 'item',
        url: '/transfer-list',
        target: false
      },
      {
        id: 'transfer-To-Other-District',
        title: 'Transfer To Other District',
        type: 'item',
        url: '/transfer-To-Other-District',
        target: false
      }
    ]
  },
  {
    id: 'transfer-orders',
    title: 'Transfer Orders',
    type: 'item',
    icon: icons.IconUsers,
    url: '/transfer-orders'
  }
];

// Filter pages if page.id is not in pagesIdAndCorrespondingRoles
const filterPages = (role: any) => {
  return pages;
};

const updateMenuItems = () => {
  const state = store.getState();
  const userRole = state.userprofile.role;
  currentMenuItems = filterPages(userRole);
};

// Initial update
updateMenuItems();

// Subscribe to store changes
store.subscribe(updateMenuItems);

export const getMenuItems = () => {
  return {
    id: 'pages',
    title: 'Pages',
    type: 'group',
    children: currentMenuItems
  };
};
